var _defs, _circle, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCloseMenuLight = function SvgCloseMenuLight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".close-menu-light-a{fill:#777e96;opacity:0.05;}.close-menu-light-b{fill:none;stroke:#242d55;stroke-width:2px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "close-menu-light-a",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.909 19.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close-menu-light-b",
    d: "M0,0H17.082",
    transform: "translate(2.502 -3.176) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "close-menu-light-b",
    d: "M0,0H17.082",
    transform: "translate(14.58 -3.176) rotate(135)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseMenuLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-menu-light.ba945540.svg";
export { ForwardRef as ReactComponent };